import store from '@/store'
import config from '@/config'

export default {
  computed: {
    screenId () {
      return (this.$route.params.screenid || 'SCREEN1').toUpperCase()
    },
    clientName () {
      return (this.$route.params.client || 'default').toLowerCase()
    },
    liveEvents () {
      var liveEvents = store.getters['livebettingState/liveEvents']
      return liveEvents && liveEvents.filter(ev => !ev.isawaitingstart)
    },
    liveEventsLoaded () {
      return store.getters['livebettingState/liveEventsLoaded']
    },
    dateFormats () {
      return config.app.dateFormats
    },
    isDebug () {
      return this.$route.query.debug || store.getters['getDebugLevel']
    },
    screenConfiguration () {
      return store.getters['cduState/getScreenConfiguration']
    },
    isToday () {
      var date = this.event && (this.event.tsDate || this.event.tsExpectedStart)
      if (date.indexOf('T') === -1) {
        date += 'T00:00:00'
      }
      const today = new Date()
      if (date) {
        // return ((new Date(date)).getDay() === (new Date()).getDay() && (new Date(date)).getDate() === (new Date()).getDate())
        return new Date(date).getDate() === today.getDate() && new Date(date).getMonth() === today.getMonth() && new Date(date).getFullYear() === today.getFullYear()
      } else {
        return false
      }
    },
    isTomorrow () {
      var date = this.event && (this.event.tsDate || this.event.tsExpectedStart)
      const day = new Date()
      const nextDay = new Date(day)
      nextDay.setDate(day.getDate() + 1)
      if (date.indexOf('T') === -1) {
        date += 'T00:00:00'
      }
      if (date) {
        // return ((new Date(date)).getDay() === ((new Date()).getDay() + 1) && (new Date(date)).getDate() === ((new Date()).getDate() + 1))
        return ((new Date(date)).getDate() === nextDay.getDate()) && (new Date(date)).getMonth() === nextDay.getMonth() && (new Date(date)).getFullYear() === nextDay.getFullYear()
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/BettingOffer.js